import { relativePageToAbsolute } from "~/utils";

import {
  setAbsolutePage,
  selectAbsolutePage
} from "~/store/ducks/user/uistate";
import { clearPagestorePage } from "~/store/ducks/domain/ui/embedded";

import {
  selectPageFlow,
  selectPageFlowIndexRange,
  selectFindPageIndex,
  selectNextPageFlowIndex,
  selectPreviousPageFlowIndex
} from "~/store/selectors/page";

export const setPage = page => (dispatch, getState) => {
  const currentPage = selectAbsolutePage(getState());

  if (page !== currentPage) {
    dispatch(setAbsolutePage(page));
    // TODO: zoomToFitAgain
    // EventBus.dispatch("zoomToFit", "main");
  }
};

export const setPageByFlowIndex = index => (dispatch, getState) => {
  if (index === -1) return;
  const pageFlow = selectPageFlow(getState());
  // Always take the first/left page
  dispatch(clearPagestorePage());
  dispatch(setPage(pageFlow[index][0]));
};

export const goToFirst = () => (dispatch, getState) => {
  const indexRange = selectPageFlowIndexRange(getState());
  dispatch(setPageByFlowIndex(indexRange[0]));
};

export const goToPrevious = () => (dispatch, getState) => {
  const previousIndex = selectPreviousPageFlowIndex(getState());
  dispatch(setPageByFlowIndex(previousIndex));
};

export const goToPage = page => (dispatch, getState) => {
  const newIndex = selectFindPageIndex(page)(getState());
  dispatch(setPageByFlowIndex(newIndex));
};

export const goToNext = () => (dispatch, getState) => {
  const nextIndex = selectNextPageFlowIndex(getState());
  dispatch(setPageByFlowIndex(nextIndex));
};

export const goToLast = () => (dispatch, getState) => {
  const indexRange = selectPageFlowIndexRange(getState());
  dispatch(setPageByFlowIndex(indexRange[1]));
};

// go to relative OR absolute page
export const goToDestination = page => (dispatch, getState) => {
  const absolute = relativePageToAbsolute(page);
  dispatch(goToPage(absolute));
};
